import * as React from 'react';

const AssortmentsEssentialsComplexIllustrationSvg = (
    props: React.SVGProps<SVGSVGElement>,
) => (
    <svg viewBox="0 0 472 340" {...props}>
        <path
            d="M275.68 77.66s-.9-6.18-5.48-6.18-14 9.81-24.85 9.81c-7.58 0-13.44-6.82-16.28-10.94a1 1 0 011.2-1.43 25.69 25.69 0 0010.25 2.43c6.67 0 18.2-13.3 28.61-13.3s9 19.34 9 19.34z"
            fill="#f6682f"
        />
        <path
            d="M197.709 230.967l189.556-37.602a1.06 1.06 0 011.246.834l20.857 105.141a1.06 1.06 0 01-.833 1.246l-188.517 37.396a1.06 1.06 0 01-1.246-.834l-21.063-106.18z"
            fill="#edeff5"
        />
        <path
            d="M267 298.16a1.07 1.07 0 01-.59-.18l-15.34-10.29a1.06 1.06 0 011.19-1.77l14.45 9.7 30-44.69a1.06 1.06 0 011.47-.29L328 270.45l23.68-35.3a1.06 1.06 0 011.77 1.19l-24.27 36.18a1.07 1.07 0 01-1.47.29L297.88 253l-30 44.69a1.07 1.07 0 01-.68.45z"
            fill="#f6682f"
        />
        <path
            fill="#363a43"
            d="M197.702 230.946l23.846-4.73 21.275 107.25-23.846 4.73z"
        />
        <path
            d="M220.18 291.51a9.78 9.78 0 01-9.56-7.89 9.77 9.77 0 1111.47 7.7 9.91 9.91 0 01-1.91.19zm0-17.42a7.64 7.64 0 00-7.5 9.12 7.64 7.64 0 107.5-9.12z"
            fill="#9b9ea7"
        />
        <path
            d="M364.467 197.861l22.795-4.522a1.06 1.06 0 011.246.834l20.863 105.17a1.06 1.06 0 01-.834 1.246l-22.795 4.522-21.275-107.25z"
            fill="#363a43"
        />
        <path
            d="M390.89 269.7a1.07 1.07 0 01-1-.86l-7.78-39.49a1.06 1.06 0 012.09-.41l7.78 39.49a1.07 1.07 0 01-.84 1.25z"
            fill="#9b9ea7"
        />
        <path
            d="M355.33 230.77l-9.08 6.37 7.43 4.51 2.1-10.59a.29.29 0 00-.45-.29z"
            fill="#f6682f"
        />
        <path
            d="M260.31 117.1s6-3 7.57-8.65c0-7.76-4.73-11.39-4.73-18.39 0-18.11 31-18.57 32.26.76s.3 32.72-8.37 29.52a19.67 19.67 0 01-6.54-4l-1.81 17z"
            fill="#ffa71a"
        />
        <path
            d="M280.5 116.39a59.24 59.24 0 01-4.67-5.57.3.3 0 00-.54.21l3.4 22.31z"
            fill="#f6682f"
        />
        <path
            d="M266.93 110.8h2.56a3.67 3.67 0 003.36-2.18l7.66-17.15h13.93l1.28 9.58a1.15 1.15 0 001.14 1h.63c2.51-23.65-9.1-27.91-19.7-27.91s-16.49 8.39-16.49 14.61 8.64 15.98 5.63 22.05z"
            fill="#282c35"
        />
        <path
            d="M137.6 254.75l-29.23 83.9H169l-29.23-83.9a1.14 1.14 0 00-2.17 0z"
            fill="#9b9ea7"
        />
        <rect
            x={90.6}
            y={218.8}
            width={18.6}
            height={129.67}
            rx={1.06}
            ry={1.06}
            transform="rotate(41.01 99.897 283.66)"
            fill="#9b9ea7"
        />
        <circle cx={107.74} cy={237.91} r={14.87} fill="#d2d6df" />
        <circle cx={96.91} cy={323.79} r={14.87} fill="#d2d6df" />
        <circle cx={217.69} cy={163.53} r={48.73} fill="#f6682f" />
        <path
            d="M212.21 157.13c6 17.15 16.27 35.93 16.27 35.93l6.28-2s-6.5-28.78-6.5-37.94l-16.05 4z"
            fill="#ffa71a"
        />
        <path
            d="M260.31 116.54s-55.59 13.08-50.8 31.83c.72 2.8 1.64 5.75 2.69 8.76l16.05-4 24-8.5z"
            fill="#282c35"
        />
        <path
            d="M345.8 166.48l2-7.11c.56-1.66 2.12-1.48 2 .68l-.28 6.16s-2.18.23-3.72.27z"
            fill="#f6682f"
        />
        <path
            d="M314.79 276.1c6.77-9.77 11.8-18.09 11.8-21.66 0-10.79-55.27-53.31-99.09-71.29 0 0-16.37 32.07 17.47 51 25.21 14.11 50.88 26.74 50.88 26.74s-4.59 5.9-10.71 15.26c8.27.03 20.13 0 29.65-.05z"
            fill="#45494e"
        />
        <path
            d="M279.5 326.06c.87-4.59 21.63-30.24 35.29-50-9.52 0-21.38.08-29.66.06-9.9 15.14-23.81 39.36-28.86 62.49h41.86c.99-3.07-19.94-5.68-18.63-12.55z"
            fill="#282c35"
        />
        <path
            d="M261.62 210.95l-34.12-27.8c-16.42 21.9-37.3 59.65-53.1 93h25.22c26.02-31 62-65.2 62-65.2z"
            fill="#45494e"
        />
        <path
            d="M174.4 276.16c-13.14 27.75-22.78 52.46-23.42 62.49h42.84c0-4.09-20.49-4.53-20.49-19.79 0-8.67 11.55-25.19 26.3-42.74-8.63.04-18.3.06-25.23.04z"
            fill="#282c35"
        />
        <path
            d="M187.55 249.67l33.77 2.09L236.58 236l7.73 10.46a1.59 1.59 0 001.69.54c5.12-1.53 27.61-8.94 46.77-26 0 0-19.89-15-29-19.27 0-19.57 19-35 21.16-52.27s-24.64-32.92-24.64-32.92a48.8 48.8 0 00-16.79 36.63c0 16.16-11.61 23.87-16 30 0-.02-12.76 13.99-39.95 66.5z"
            fill="#9b9ea7"
        />
        <rect
            x={205.94}
            y={160.91}
            width={26.11}
            height={7.85}
            rx={1.06}
            ry={1.06}
            transform="rotate(-14.11 218.955 164.801)"
            fill="#282c35"
        />
        <path
            d="M318 48.68l-1 11.17L346.45 157l2.66-.76 2.71-.78-26.48-98-6.69-9a.38.38 0 00-.65.22z"
            fill="#f6682f"
        />
        <path
            fill="#45494e"
            d="M361.35 154.62l-8.52 3.98-5.78 1.65-9.16 1.14-.52-1.82 23.48-6.72.5 1.77z"
        />
        <path
            d="M357.57 175.15l-4.74-16.55-5.78 1.65 4.74 16.55a1.06 1.06 0 001.32.73l3.73-1.07a1.06 1.06 0 00.73-1.31z"
            fill="#45494e"
        />
        <rect
            x={343.9}
            y={313.32}
            width={25.22}
            height={25.22}
            rx={1.06}
            ry={1.06}
            fill="#9b9ea7"
        />
        <path
            d="M275 75.22h3.2c0-1.09 0-2.5-.17-4.05a10.69 10.69 0 00-5.03 1.31 7.09 7.09 0 012 2.74z"
            fill="#282c35"
        />
        <path
            d="M274 172.36s-16.79-20.93-16.79-32.27 15.16-19 25-2.62l20.36 34.89z"
            fill="#9b9ea7"
        />
        <path
            d="M224.28 200.32c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.82c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5a9.93 9.93 0 002.9 2.25c0-.39.07-.77.11-1.15a10 10 0 01-2.25-1.85c-1.38-1.38-2.8-2.81-5.66-2.81-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.82c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5-.3-.3-.68-.72-1-1l-.59.91c.26.24.59.61.84.86 1.37 1.36 2.78 2.79 5.65 2.79zM245.52 145c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.67 2.82c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49 3.63 1.22 4.91 2.5a7.91 7.91 0 004.4 2.7l-.76-1.31a8.29 8.29 0 01-2.88-2.14c-1.38-1.38-2.8-2.81-5.66-2.82-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.67-2.82c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49a6.12 6.12 0 01-1.08-.1c-.07.35-.14.69-.2 1a7.29 7.29 0 001.27.17zM256.06 182.93c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.82c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49a4.58 4.58 0 01-.66-.07l-.7 1a7.83 7.83 0 001.35.16c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.82c2.86 0 4.28-1.42 5.66-2.8S253.62 184 256 184c2.43 0 3.63 1.22 4.91 2.5s2.66 2.64 5.23 2.79c.13-.35.25-.69.39-1-2.39 0-3.6-1.22-4.87-2.5s-2.74-2.86-5.6-2.86zM261.06 120.06c1.38 1.38 2.8 2.81 5.66 2.82a6.82 6.82 0 002.1-.32l-1.07-.84a6.16 6.16 0 01-1 .09c-2.43 0-3.63-1.22-4.91-2.5a11.36 11.36 0 00-2.41-2l-.84.77a9.25 9.25 0 012.47 1.98zM213.62 249.3a6.44 6.44 0 00-4.5 1.7l1.66.1a5.35 5.35 0 012.84-.74 5.35 5.35 0 013.38 1.14l1.74.11a6.82 6.82 0 00-5.12-2.31zM256 238.29c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49-3.63-1.22-4.91-2.5l-.27-.27 2.36 3.24a6.52 6.52 0 002.82.6c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49a6 6 0 014.59 2.18l1-.47c-1.35-1.37-2.77-2.77-5.59-2.78zM272.32 175.44c-1.38 1.38-2.8 2.8-5.66 2.8-2.87 0-4.29-1.43-5.67-2.82s-2.49-2.5-4.91-2.5-3.63 1.21-4.91 2.49-2.8 2.8-5.66 2.8c-2.87 0-4.29-1.43-5.66-2.81a7.32 7.32 0 00-3.5-2.33l.7-.91a8.76 8.76 0 013.56 2.5c1.28 1.28 2.49 2.5 4.91 2.5s3.63-1.21 4.91-2.49 2.8-2.8 5.66-2.8c2.87 0 4.29 1.43 5.67 2.82s2.49 2.5 4.91 2.5 3.63-1.21 4.91-2.49zM213.68 206.08c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.82c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.81c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.67 2.81c2.86 0 4.28-1.42 5.66-2.8a16.58 16.58 0 011.3-1.2l-.94-.61c-.39.34-.75.7-1.11 1.06-1.28 1.28-2.49 2.49-4.91 2.49-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.82a11.52 11.52 0 00-1.33.21l-.78 1.28a7.41 7.41 0 012.11-.42zM203.07 233.51c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.81c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.81c2.86 0 4.28-1.42 5.66-2.8s2.52-2.46 4.92-2.49 3.63 1.22 4.91 2.5 2.8 2.81 5.66 2.81c2.86 0 4.28-1.42 5.66-2.8s2.46-2.49 4.92-2.49a5.6 5.6 0 014.09 1.7l.9-.62a6.7 6.7 0 00-5-2.15c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.67-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.4 0-3.73-1.26-5-2.53l-.5.92c1.3 1.3 2.8 2.67 5.49 2.68zM266.71 132.88c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.82c-2.86 0-4.28 1.42-5.66 2.8a10.82 10.82 0 01-2.06 1.74q-.35.72-.69 1.47a8.85 8.85 0 003.5-2.46c1.28-1.28 2.49-2.49 4.91-2.49 2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.67 2.82c2.86 0 4.28-1.42 5.66-2.8a7.48 7.48 0 013.37-2.29l-.82-.85a9.18 9.18 0 00-3.3 2.39c-1.28 1.28-2.49 2.49-4.91 2.49zM213.64 239.3c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.81c2.86 0 4.28-1.42 5.66-2.8a8 8 0 013-2.18l1.28-1.34c-2.45.19-3.78 1.49-5 2.76s-2.49 2.49-4.91 2.49-3.63-1.22-4.91-2.5-2.8-2.81-5.66-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5a8.09 8.09 0 00-4.59-2.75l-.5.94c2 .19 3.17 1.39 4.33 2.56 1.38 1.38 2.8 2.81 5.66 2.82 2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49zM277.27 149.74c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.67-2.82c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49a5.59 5.59 0 01-2-.36c0 .38 0 .74-.07 1.11a6.84 6.84 0 002.09.32c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.82c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.81a6.4 6.4 0 004.35-1.58l-.54-.93a5.46 5.46 0 01-3.8 1.45c-2.42 0-3.63-1.22-4.91-2.5s-2.81-2.82-5.68-2.82zM296.11 161.23a9.09 9.09 0 00-3.36 2.41c-1.28 1.28-2.49 2.49-4.91 2.49-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.82c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.67-2.82c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49a5.6 5.6 0 01-4.08-1.69q-.21.53-.44 1a6.45 6.45 0 004.51 1.72c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.67 2.82c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49 3.63 1.22 4.91 2.5 2.8 2.81 5.67 2.82c2.86 0 4.28-1.42 5.66-2.8a7.8 7.8 0 013.15-2.23zM203.09 222.44c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.67 2.82c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49c2.43 0 3.63 1.22 4.91 2.5s2.8 2.81 5.66 2.81c2.86 0 4.28-1.42 5.66-2.8s2.5-2.47 4.92-2.49 3.63 1.22 4.91 2.5 2.8 2.81 5.67 2.81c2.86 0 4.28-1.42 5.66-2.8s2.49-2.49 4.91-2.49 3.63 1.22 4.91 2.5 2.8 2.81 5.66 2.81a6.52 6.52 0 004.66-1.84l-.88-.65a5.46 5.46 0 01-3.79 1.43c-2.42 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.67-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.81c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49c-2.43 0-3.63-1.22-4.91-2.5s-2.8-2.81-5.66-2.82c-2.86 0-4.28 1.42-5.66 2.8s-2.49 2.49-4.91 2.49a.53.53 0 01-.22-.06l-.57 1a3.39 3.39 0 00.78.11z"
            fill="#6d717a"
        />
        <path
            d="M275.35 172.36H274s-13.63-17-16.32-28.65a3 3 0 00-.3 1.52c1.37 21.6 10.67 39.22 7.35 48.66 2.21-7.53 6.58-14.89 10.62-21.53z"
            fill="#45494e"
        />
        <path
            d="M274 172.36s13 17 32.43 17c27.39 0 49.65-18.86 49.65-18.86s5.4-4.36 2.45-8.88c-2.47-3.8-5.75-3-5.75-3l1 3.34s-12.78 10.4-51.17 10.4z"
            fill="#ffa71a"
        />
        <path
            d="M471 340l-470-.07a1.13 1.13 0 010-2.24l470 .07a1.13 1.13 0 010 2.24z"
            fill="#282c35"
        />
    </svg>
);

AssortmentsEssentialsComplexIllustrationSvg.displayName =
    'AssortmentsEssentialsComplexIllustrationSvg';
export default AssortmentsEssentialsComplexIllustrationSvg;
